import React from "react"
import { useSpringCarousel } from 'react-spring-carousel-js'
import { StaticImage } from "gatsby-plugin-image"
import styled from "styled-components"

const FullScreen = styled.div`
    // width: 80%;
    margin: 0 auto;
`


const CarouselWrapper = styled.div`
    // display: flex;
    // height: 400px;
`
const CarouselItem = styled.div`
    // height: 80vh;
    //margin: 0 5%;
    height: 500px;
    img {
      height: 500px;
    }
`
const ThumbsWrapper = styled.div`
    display: flex;
    //margin: 0 5%;
    padding-top: 1rem;
`



const ThumbItem = styled.a`

    &:before {
            content: " ";
            width: 40px;
            display: block;
            height: 4px;
            position: relative;
            background: ${(props) => props.theme.colors.primary};
    } 
    float: left;
    position: relative;
    height: 100%;
    margin-right: 0.5rem;
`




const FullScreenCarousel = ({ children }: any) => {
    console.log(children);
  const {
    carouselFragment,
    thumbsFragment,
    slideToItem,
    slideToPrevItem,
    slideToNextItem,
    
  } = useSpringCarousel({
    withLoop: true,
    itemsPerSlide: 1,
    withThumbs: true,
    items: [
      {
        id: "CarouselItem-1",
        renderItem: (<CarouselItem background="#2c3e50">
                        {/* <StaticImage src="../../images/textile.jpeg" alt="Textiles" /> */}
                        {children[0]}
                    </CarouselItem>),
        renderThumb: (
          <ThumbItem onClick={() => slideToItem("CarouselItem-1")}>
          </ThumbItem>
        ),
      },
      {
        id: "CarouselItem-2",
        renderItem: (<CarouselItem background="#c0392b">
                        {children[1]}
                    </CarouselItem>),
        renderThumb: (
          <ThumbItem onClick={() => slideToItem("CarouselItem-2")}>
          </ThumbItem>
        ),
      },
      {
        id: "CarouselItem-3",
        renderItem: (<CarouselItem background="#c0392b">
                        {children[2]}
                    </CarouselItem>),
        renderThumb: (
          <ThumbItem onClick={() => slideToItem("CarouselItem-3")}>
          </ThumbItem>
        ),
      },
    ],
  });

  return (
    <FullScreen>
        <CarouselWrapper>
            {carouselFragment}
        </CarouselWrapper>
        <ThumbsWrapper>{thumbsFragment}</ThumbsWrapper>
    </FullScreen>
  );
}

export default FullScreenCarousel;